export enum InstallType {
  Assign = 'ASSIGN',
  UnAssign = 'UNASSIGN',
  Update = 'UPDATE',
}
